// Tab switching functionality for login page
// Converted from jQuery fadeIn/fadeOut to vanilla JS with CSS transitions

document.addEventListener('DOMContentLoaded', () => {
  // Only run on devise pages
  const deviseBody = document.querySelector('body.devise')
  if (!deviseBody) return

  const rhsWrapper = document.querySelector('.ap__rhs-wrapper')
  const tabs = document.querySelectorAll('.ap__tab')
  const switchContent = document.querySelectorAll('.ap__rhs-switch')
  const blurbContent = document.querySelectorAll('.sb__content-wrapper')

  if (tabs.length < 2 || switchContent.length < 2 || blurbContent.length < 2 || !rhsWrapper) return

  const tabPartner = tabs[0]
  const tabRetail = tabs[1]
  const switchContentPartner = switchContent[1]
  const switchContentRetail = switchContent[0]
  const blurbContentPartner = blurbContent[0]
  const blurbContentRetail = blurbContent[1]

  function fadeOut(element) {
    element.style.opacity = '1'
    element.style.transition = 'opacity 0.3s ease'
    element.style.opacity = '0'

    setTimeout(() => {
      element.style.display = 'none'
    }, 300)
  }

  function fadeIn(element) {
    element.style.display = ''
    element.style.opacity = '0'
    element.style.transition = 'opacity 0.3s ease'

    // Trigger reflow for transition
    element.offsetHeight

    element.style.opacity = '1'
  }

  tabPartner.addEventListener('click', () => {
    tabPartner.classList.add('active')
    tabRetail.classList.remove('active')
    rhsWrapper.classList.remove('retail')
    rhsWrapper.classList.add('partner')
    fadeIn(switchContentPartner)
    fadeOut(switchContentRetail)
    fadeIn(blurbContentPartner)
    fadeOut(blurbContentRetail)
  })

  tabRetail.addEventListener('click', () => {
    tabPartner.classList.remove('active')
    tabRetail.classList.add('active')
    rhsWrapper.classList.remove('partner')
    rhsWrapper.classList.add('retail')
    fadeOut(switchContentPartner)
    fadeIn(switchContentRetail)
    fadeOut(blurbContentPartner)
    fadeIn(blurbContentRetail)
  })
})
